import { Box, Drawer, makeStyles, Tab, Tabs } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { useMemo, useState } from "react";
import { analysisTabConfig, scoringTabConfig } from "src/config/constants/layout";
import { useUserContext } from "src/context/config/userContext";
import ProductionMenu from "./ProductionMenu";
import TabMenu from "./TabMenu";

const useStyles = makeStyles((theme) => ({
  menuBar: {
    zIndex: 1500,
    position: "fixed",
  },
  tab: {
    textTransform: "capitalize",
    color: theme.palette.text.secondary,
  },
  icon: {
    color: theme.palette.text.secondary,
  },
}));

export default function MobileMenu() {
  const cls = useStyles();
  const [value, setValue] = useState(() => {
    const scoring = ["credit-score", "token-health", "reputation", "portfolio"];
    var path = location.pathname.toString();
    for (let i = 0; i < scoring.length; i++) {
      if (path.includes(scoring[i])) return 0;
    }
    return 1;
  });
  const [toggle, setToggle] = useState([false, false, false]);
  const { role } = useUserContext();

  const realAnalysisTabConfig = useMemo(() => {
    if (role === "admin") return analysisTabConfig;
    else return analysisTabConfig.filter((element) => !element.isAdmin);
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleToggle = (open) => {
    if (toggle[open]) setToggle([false, false, false]);
    else if (!toggle[open]) {
      setToggle(() => {
        var temp = [false, false, false];
        temp[open] = true;
        return temp;
      });
    }
  };

  return (
    <Drawer open variant="permanent" anchor="bottom" className={cls.menuBar} PaperProps={{ style: { padding: 0 } }}>
      <Tabs value={value} onChange={handleChange} variant="fullWidth" indicatorColor="primary" textColor="primary">
        <Tab disableRipple disableFocusRipple label="Scoring" onClick={() => handleToggle(0)} className={cls.tab} />
        <Tab disableRipple label="Analytics" onClick={() => handleToggle(1)} className={cls.tab} />
        <Tab disableRipple icon={<MenuIcon className={cls.icon} />} onClick={() => handleToggle(2)} />
      </Tabs>
      <Box>
        <TabMenu
          tabType={scoringTabConfig}
          open={toggle[0]}
          closeMenu={() => {
            setToggle([false, false, false]);
          }}
        />
        <TabMenu
          tabType={realAnalysisTabConfig}
          open={toggle[1]}
          closeMenu={() => {
            setToggle([false, false, false]);
          }}
        />
        <ProductionMenu
          open={toggle[2]}
          closeMenu={() => {
            setToggle([false, false, false]);
          }}
        />
      </Box>
    </Drawer>
  );
}
